import { render, staticRenderFns } from "./TransactionsDetail.vue?vue&type=template&id=accc015e&"
import script from "./TransactionsDetail.vue?vue&type=script&lang=js&"
export * from "./TransactionsDetail.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports